const data = [
  {
    name: "AuthenticationCallback"
  }
];

export default data;
